import { mode, Styles } from "@chakra-ui/theme-tools";
import { SpinnerGif } from "../common/assets/images";

export const styles: Styles = {
  global: (props) => ({
    "html, body, #root": {
      p: 0,
      m: 0,
    },
    html: {
      WebkitTextSizeAdjust: "none",
      touchAction: "pan-x pan-y",
    },
    body: {
      backgroundColor: mode("sapphireBlue.600", "sapphireBlue.600")(props),
      color: mode("black", "black")(props),
    },
    video: {
      bg: `transparent url(${SpinnerGif}) 50% 50% / 20% auto no-repeat`,
      bgColor: "sapphireBlueAlpha.800",
      objectFit: { base: "cover !important", md: "contain !important" },
    },
    ".vid": {
      position: "relative",
      height: "full",
      flex: "1",
      width: "full",
      bgColor: "sapphireBlueAlpha.800",
    },
    ".js-focus-visible :focus:not([data-focus-visible-added])": {
      outline: "none",
      boxShadow: "none",
    },
    "*": {
      WebkitTapHighlightColor: "transparent",
    },
    "iframe:not([id]):not([data-intercom-frame='true'])": {
      position: "absolute !important",
      left: `11111px !important`,
    },
  }),
};
